// extracted by mini-css-extract-plugin
module.exports = {"spinner":"spinner_spinner__3KFGV","spinner1":"spinner_spinner1__9FliE","spinner2":"spinner_spinner2__1ZIoQ","spinner3":"spinner_spinner3__GsrF3"};